



import Vue from 'vue'
import Resp from '@/models/resp/Resp'
import statusComponent from '@/components/Resp/status.vue'

export default Vue.extend({
  name: 'RespStatusColumn',
  props: {
    row: Object as () => Resp
  },
  components: {
    statusComponent
  }
})
